import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api, formatUGX } from "@/lib/api";
import { ArrowRight, MapPin } from "lucide-react";

export default function ListingsTicker() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api.get("/properties", { params: { limit: 6 } })
      .then((r) => { if (!cancelled) setItems(r.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!items.length) return null;
  // duplicate content for seamless infinite marquee
  const row = [...items, ...items];

  return (
    <section className="border-y border-border bg-background overflow-hidden" data-testid="listings-ticker" aria-label="Latest listings">
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />
        <div className="flex items-center py-4 gap-4">
          <div className="pl-6 md:pl-12 shrink-0 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            <span className="text-[11px] tracking-[0.22em] uppercase font-bold text-primary">Latest · Live</span>
          </div>
          <motion.div
            className="flex items-center gap-3 whitespace-nowrap will-change-transform"
            animate={{ x: ["0%", "-50%"] }}
            transition={{ duration: 40, ease: "linear", repeat: Infinity }}
          >
            {row.map((p, i) => (
              <Link
                key={`${p.id}-${i}`}
                to={`/listings/${p.id}`}
                className="group inline-flex items-center gap-3 pl-2 pr-4 py-1.5 rounded-full border border-border hover:border-primary hover:bg-muted/60 transition-colors"
                data-testid={`ticker-item-${p.id}`}
              >
                <div className="w-8 h-8 rounded-full overflow-hidden bg-muted shrink-0">
                  <img src={p.images?.[0]} alt="" className="w-full h-full object-cover" />
                </div>
                <span className="text-sm font-semibold max-w-[240px] truncate">{p.title}</span>
                <span className="hidden md:inline-flex items-center gap-1 text-[11px] text-muted-foreground font-mono">
                  <MapPin className="w-3 h-3" /> {p.district}
                </span>
                <span className="font-mono text-xs font-bold text-primary">{formatUGX(p.price_ugx)}</span>
                <ArrowRight className="w-3.5 h-3.5 text-muted-foreground group-hover:text-primary group-hover:translate-x-0.5 transition-all" />
              </Link>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
